import { render, staticRenderFns } from "./customerorder.vue?vue&type=template&id=ffac5dd8&scoped=true&"
import script from "./customerorder.vue?vue&type=script&lang=js&"
export * from "./customerorder.vue?vue&type=script&lang=js&"
import style0 from "./customerorder.vue?vue&type=style&index=0&id=ffac5dd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffac5dd8",
  null
  
)

export default component.exports